import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'BaseDataService',
    controller: 'Equipment'
};

const methods = [
    'AddEquipment',
    'UpdateEquipment',
    'GetEquipmentById',
    'DelEquipment',
    'GetEquipmentPagingList',
    'GetEquipmentMangeList'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const MonitorApi = ZJApi.defineNewApi('MonitorApi', factory);

export default MonitorApi;